module.exports = __webpack_public_path__ + "static/img/code3.39afe21.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/code3.jpg
// module id = eIeE
// module chunks = 1